import * as React from 'react';
import { useAppDispatch } from 'store/store';
import { refreshTokenAsyncThunk } from 'store/users/users.action';
import { clearUser } from 'store/users/users.slices';

export const useSilentLogin = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(
      refreshTokenAsyncThunk({
        isSilentLogin: true,
        onError: () => dispatch(clearUser()),
      })
    );
  }, [dispatch]);
};
